import React, { ReactNode } from 'react';
import { usePageMeta, useShareUrls } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { ShareContextProvider } from '../../context/ShareContext';

interface TeamInviteShareProps {
  children: ReactNode;
}

export function TeamInviteShare({ children }: TeamInviteShareProps) {
  const { t } = useTranslation('common', { useSuspense: false });
  const { currentUrl } = usePageMeta();

  const emailMapper = (url: string) => {
    const shareMessage = t(
      'team.inviteMessage.message',
      'I´ve created a fundraising team on JustGiving, and I´d like you to join. Check out my team page and join:',
    );

    return {
      subject: t('team.inviteMessage.subject', 'Join my fundraising team!'),
      body: `${t(
        'common.greeting',
        'Hello',
      )},\n\n${shareMessage}\n\n${url}\n\n`,
    };
  };

  const shareItems = useShareUrls(
    {
      email: emailMapper,
    },
    `${currentUrl}?invite=true`,
  );

  return (
    <ShareContextProvider value={{ shareItems }}>
      {children}
    </ShareContextProvider>
  );
}
